import React from 'react';
import LibraryBooksIcon from "@material-ui/icons/LibraryBooks";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import dayjs from "dayjs";
import CheckIcon from '@material-ui/icons/Check';
import DoneAllIcon from '@material-ui/icons/DoneAll';

const CourseDetail = ({percentComplete, myCourse}) => {
    return (
        <div className="course-item-right">
            {(myCourse.completionType === 1 && myCourse.finalTestCorrectRate) || percentComplete === 100 ?
                <div>
                    <div className="title-course title-success">
                        {myCourse.name}<CheckIcon/>
                    </div>
                </div> :
                <div>
                    <div className="title-course">
                        {myCourse.name}
                    </div>
                </div>}

            {myCourse.finalTestQuestionCount !== 0 && myCourse.completionType === 1 && myCourse.finalTestCorrectRate ?
                <div className="book-course">
                    <DoneAllIcon/> {myCourse.finalTestCorrectCount}/{myCourse.finalTestQuestionCount}
                </div> : myCourse.numberOfLessons ?
                <div className="book-course">
                    <LibraryBooksIcon/> {myCourse.completedLessons}/{myCourse.numberOfLessons}
                </div> : <> <LibraryBooksIcon/> '0/0' </>
            }
            <div className="date-course">
                <AccessTimeIcon/>{dayjs(myCourse.endTime).format('DD/MM/YYYY')}
            </div>
        </div>
    )
};

export default CourseDetail;